(function() {
    $.extend(freshop, {
        on: function(event, callback) {
            if(fp.clientEvents.on[event] && _.isFunction(callback)) {
                if(fp.initialized && event === fp.events.INITIALIZED) {
                    _.defer(callback.bind(freshop, $.Event(event)));
                }
                else $(this).on(event, callback);
            }

            return this;
        },
        off: function(event, callback) {
            if(fp.clientEvents.on[event]) $(this).off(event, callback);

            return this;
        },
        
        //remove this when Wordpress implements Mini List Indicator module / freshop.ui.trigger
        trigger: function(selector, event, data) {
            //update this to require selector when Wordpress no longer implements non-standard public Freshop events
            if(_.isString(selector) && fp.clientEvents.trigger[selector]) {
                data = event;
                event = selector;
                selector = undefined;
            }

            //remove this when Wordpress implements freshop.ui.trigger(selector, 'resize')
            if(event === fp.events.MEDIA_WIDTH_CHANGE) data = _.getObject(data);

            //fp.log('Trigger client event', event, fp.clientEvents.trigger[event], data);

            if(!fp.clientEvents.trigger[event]) return;

            return fp.trigger(event, data, selector);
        },
        invoke: function(url, payload, options, onSuccess, onFailure, always) {
            options = $.extend({}, options, {
                // cache: false,
                prepareJsonData: false,
                handleErrors: false,
                ignoreErrors: true
            });

            var promise = fp.api(url, payload, options);

            //removeIf(!debug)

            // if(fp.disableRender) {
            //     promise = promise.then(function() {
            //         return {};
            //     });
            // }

            //endRemoveIf(!debug)

            fpUtil.applyCallback(onSuccess, onFailure, always, promise);
        },
        login: function(email, password, onSuccess, onFailure, always) {
            var promise = fpService.userMeService
                .post({
                    email: email,
                    password: password
                }, {
                    childServiceCall: 'sessions'
                })
                .then(function () {
                    return fp.initLogin({autoRedirect: true});
                });

            fpUtil.applyCallback(onSuccess, onFailure, always, promise);
        },
        logout: function(onSuccess, onFailure, always) {
            fpUtil.applyCallback(onSuccess, onFailure, always, fp.logout())
                .deferred()
                .resolve();
        },
        getCurrentSession: function (onSuccess, onFailure, always) {
            fpUtil.applyCallback(onSuccess, onFailure, always)
                .deferred()
                .resolve($.extend(true, {}, fp.session));
        },
        getCurrentUser: function (onSuccess, onFailure, always) {
            let item = $.extend(true, {}, fp.user);
            delete item.address;

            fpUtil.applyCallback(onSuccess, onFailure, always)
                .deferred()
                .resolve(item);
        },
        getCurrentStore: function (onSuccess, onFailure, always, options) {
            const urlParams = fpUi.router.routeManager.urlParams;
            let promise,
                storeId;
            if(!fp.loaded && options?.enablePreload && !(fp.store.id || urlParams.store_id || urlParams.store_number)) {
                if(fpUtil.isAuthenticated()) storeId = fp.user.selected_store_id || fp.getPrefCookie().store_id;
                else storeId = fp.getSelectedStoreId();
            }

            if(storeId && storeId !== fp.store.id) {
                promise = fpService.storeService
                    .get(storeId, {
                        ignoreErrors: true
                    })
                    .catch(function() {
                        return {};
                    });
            }
            else {
                promise = $.Deferred().resolve($.extend(true, {}, fp.store)).promise();
            }

            if(options?.ensureOtherAttributes !== false) {
                promise = promise
                    .then(function(resp) {
                        return fp.ensureStoreOtherAttributes(resp);
                    });
            }

            fpUtil.applyCallback(onSuccess, onFailure, always, promise);
        },
        getFulfillmentType: function(onSuccess, onFailure, always) {
            var deferred = $.Deferred(),
            	fulfillmentTypeId = fp.user.preference.fulfillmentTypeId || fp.getPrefCookie().fulfillmentTypeId,
                promiseUser;

            if(!fulfillmentTypeId && !fp.user.id && fp.session.is_user_logged_in) {
                promiseUser = fpService.userMeService
                    .get()
                    .then(function(resp) {
                        fulfillmentTypeId = resp.preference && resp.preference.fulfillmentTypeId;
                    });
            }

            $.when(promiseUser)
                .always(function() {
                    if(fulfillmentTypeId) {
                        freshop.invoke('fulfillment_types/' + fulfillmentTypeId, null, null, onSuccess, onFailure, always);
                    }
                    else deferred.reject('No fulfillment type');
                });
        	
            fpUtil.applyCallback(onSuccess, onFailure, always, deferred.promise());
        },
        getStores: function (onSuccess, onFailure, always) {
            this.invoke('stores', {
                    limit: -1,
                    is_selectable: true,
                    fields: 'id,number,store_number,name,state,is_selectable'
                },
                null,
                onSuccess,
                onFailure,
                always
            );
        }
    });
})();